import axios from 'axios';

/**
 * Get Cities for payments
 * @param {string} query query string params
 */
export const getCities = () => {
    return axios.get(`${process.env.REACT_APP_API_URL}/cities`)
};